var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('p',[_vm._v("Loading map data...")]):_c('svg-graph',{attrs:{"graphData":_vm.graph}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }